import React, { ReactNode } from "react";
import { defaultLoader, loaderWrapper } from "@components/table/table.styles";

function TableLoader({ children }: { readonly children: ReactNode }) {
    return (
        <div className={loaderWrapper}>
            <div className={defaultLoader}>{children}</div>
        </div>
    );
}

export default TableLoader;
